import React, { useEffect } from 'react';
import { useSortBy, useTable, usePagination } from "react-table";
import { useColumns } from "../../../shared/components/Table/utils";
import Table from "../../../shared/components/Table";
import { getEmptyStatTableValues, checkNextPage } from "../../../shared/utils";
import Pagination from "../../../shared/components/Pagination";
import { NoResults } from "../../../shared/svg/Svg";
import { useStatsData } from "../../utils";
import { actionTypes } from "../../../shared/hooks/useFilters";
import { useReactAppState } from "../../../shared/containers/utils";

const PlayerStatsTable = ({ baseClass, emptyResultsComponent }) => {
  const { t } = useReactAppState();

  const {
    statType,
    currentQueryType,
    page,
    updateFilter,
    playersData,
    preSelectedClub,
    season
  } = useStatsData();

  const columns = useColumns(season === "all" ? `${currentQueryType}_ALL_YEARS` : currentQueryType, playersData);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    setSortBy,
    state: { sortBy },
  } = useTable(
    {
      columns,
      data: playersData && playersData.length > 0
        ? playersData
        : playersData && playersData.length === 0
          ? []
          : getEmptyStatTableValues(30).items,
      manualPagination: true,
      manualSortBy: true,
      autoResetPage: true,
      autoResetSortBy: false,
      disableMultiSort: true,
      disableSortRemove: true,
      initialState: {
        sortBy: [{ id: statType, desc: true }]
      },
    },
    useSortBy,
    usePagination,
  );

  const { desc: descending, id } = sortBy[0] || {};

  useEffect(() => {
    if (!statType) {
      return;
    }
    setSortBy([{ id: statType, desc: true }]);
  }, [statType]);

  useEffect(() => {
    if (!id) {
      updateFilter(actionTypes.statType)(null);
    } else {
      updateFilter(actionTypes.desc)({ desc: descending, statType: id });
    }
  }, [descending, id]);

  const canNextPage = checkNextPage(playersData, 30);

  return (
    <>
      <Table
        baseClass={baseClass}
        getTableBodyProps={getTableBodyProps}
        getTableProps={getTableProps}
        rows={rows}
        headerGroups={headerGroups}
        state={sortBy}
        prepareRow={prepareRow} />
      {
        rows.length < 1
          ? (
            <div className="mls-c-stats__no-results">
              <NoResults size="large" />
              <div className="mls-c-stats__no-results-text">{t("no_players_found")}</div>
              {
                emptyResultsComponent ? emptyResultsComponent : null
              }
            </div>
          )
          : preSelectedClub
            ? null
            : (
              <div className="mls-c-stats__pagination">
                <Pagination canNextPage={canNextPage} updateFilter={updateFilter(actionTypes.page)} page={page} />
              </div>
            )
      }
    </>
  );
};

export default PlayerStatsTable;
